import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { recover } from "@/api";
import { useAuth } from "@/auth";
import { RECOVER } from "@/constants/testIds";

const Recover = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [codename, setCodename] = useState("");
  const [passphrase, setPassphrase] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await recover(codename.trim(), passphrase);
      await refresh();
      navigate("/account");
    } catch (e) {
      setErr(
        typeof e?.response?.data?.detail === "string"
          ? e.response.data.detail
          : "Could not recover codename."
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="term-container fade-in" data-testid={RECOVER.root}>
      <div className="kbd-label">// recovery</div>
      <h1 style={{ margin: "0.2rem 0 1rem", color: "var(--ax-accent)" }}>
        RECOVER CODENAME
      </h1>
      <p className="muted" style={{ maxWidth: 500 }}>
        Restore an existing AXIOM session on this device. Requires your
        codename + the passphrase you set on your other device.
      </p>

      <form onSubmit={submit} style={{ maxWidth: 420, marginTop: "1.5rem" }}>
        <label className="kbd-label" htmlFor="codename">
          CODENAME
        </label>
        <input
          id="codename"
          data-testid={RECOVER.codenameInput}
          value={codename}
          onChange={(e) => setCodename(e.target.value)}
          placeholder="e.g. QuietRaven4821"
          autoComplete="username"
          required
        />
        <div style={{ height: 12 }} />
        <label className="kbd-label" htmlFor="pp">
          PASSPHRASE
        </label>
        <input
          id="pp"
          data-testid={RECOVER.passphraseInput}
          type="password"
          value={passphrase}
          onChange={(e) => setPassphrase(e.target.value)}
          placeholder="your passphrase"
          autoComplete="current-password"
          minLength={8}
          required
        />
        <div style={{ marginTop: "1rem" }}>
          <button
            type="submit"
            data-testid={RECOVER.submit}
            disabled={busy || !codename || passphrase.length < 8}
          >
            {busy ? "RECOVERING…" : "RECOVER"}
          </button>
          <Link to="/" style={{ marginLeft: "1rem", fontSize: 12 }}>
            cancel
          </Link>
        </div>
        {err && (
          <div style={{ color: "var(--ax-danger)", marginTop: 12, fontSize: 12 }}>
            {err}
          </div>
        )}
      </form>
    </div>
  );
};

export default Recover;
